"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetSystems = exports.getRandomFreeSystem = exports.getRandomFloor = exports.getSystemByIdSafe = exports.getSystemById = exports.getSystemByKeySafe = exports.getSystemByKey = exports.networkAddSystem = exports.addGameSystem2 = exports.addGameSystem = exports.getElevators = exports.addGameElevator = exports.convertJtoY = exports.convertItoX = exports.convertIJtoXY = exports.convertSXtoI = exports.convertSYtoJ = exports.convertYtoJ = exports.convertXtoI = exports.getIJAtMouse = exports.update = exports.getSafeOffset = exports.getSafeXY = exports.getSafeIJ = exports.getSafe = exports.getUnsafe = exports.inRange = exports.create = exports.spotSize = exports.get = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageMessageSystemCreate_sidecar_1 = require("@voyage/multi/voyageMessageSystemCreate-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var voyageSystems_sidecar_1 = require("@voyage/systems/voyageSystems-sidecar");
var voyageSystemsData_sidecar_1 = require("@voyage/systems/voyageSystemsData-sidecar");
var voyageTileData_1 = require("./voyageTileData");
var voyageTilemapPart_sidecar_1 = require("./voyageTilemapPart-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var _obj = null;
function get() {
    assert_sidecar_1.assert.notNil(_obj, 'tilemap not created');
    return _obj;
}
exports.get = get;
exports.spotSize = 40;
function create() {
    var obj = {
        parts: [],
        width: 0,
        height: 0,
        // x: 0,
        // y: 0,
        elevators: {},
        systemsByKey: {},
        systemsById: {},
        systems: [],
        nextSystemId: 0,
        // breaches: [],
    };
    setSize(obj, 100, 100);
    _obj = obj;
    resetSystems();
    return obj;
}
exports.create = create;
function setSize(obj, width, height) {
    obj.width = width;
    obj.height = height;
    obj.parts = [];
    // TODO: kill existing?
    for (var j = 0; j < height; j++) {
        for (var i = 0; i < width; i++) {
            var gs = voyageTilemapPart_sidecar_1.voyageTilemapPart.create(i, j, i * exports.spotSize + exports.spotSize / 2, j * exports.spotSize + exports.spotSize / 2);
            obj.parts.push(gs);
        }
    }
}
function inRange(i, j) {
    var obj = get();
    return i >= 0 && i < obj.width && j >= 0 && j < obj.height;
}
exports.inRange = inRange;
function getUnsafe(i, j) {
    var obj = get();
    assert_sidecar_1.assert.t(inRange(i, j), 'not in range', i, j);
    return obj.parts[i + j * obj.width];
}
exports.getUnsafe = getUnsafe;
function getSafe(i, j) {
    var obj = get();
    if (!inRange(i, j)) {
        return null;
    }
    return obj.parts[i + j * obj.width];
}
exports.getSafe = getSafe;
function getSafeIJ(iij) {
    return getSafe(iij.i, iij.j);
}
exports.getSafeIJ = getSafeIJ;
function getSafeXY(ixy) {
    var i = convertXtoI(ixy.x);
    var j = convertYtoJ(ixy.y);
    return getSafe(i, j);
}
exports.getSafeXY = getSafeXY;
function getSafeOffset(iij, oi, oj) {
    return getSafe(iij.i + oi, iij.j + oj);
}
exports.getSafeOffset = getSafeOffset;
function update() { }
exports.update = update;
function getIJAtMouse() {
    var s = common_sidecar_1.common.getPhaserScene();
    var mx = s.input.mousePointer.x;
    var my = s.input.mousePointer.y;
    var i = convertSXtoI(mx);
    var j = convertSYtoJ(my);
    return { i: i, j: j };
}
exports.getIJAtMouse = getIJAtMouse;
function convertXtoI(_x) {
    var i = Math.floor(_x / exports.spotSize);
    return i;
}
exports.convertXtoI = convertXtoI;
function convertYtoJ(_y) {
    var j = Math.floor(_y / exports.spotSize);
    return j;
}
exports.convertYtoJ = convertYtoJ;
function convertSYtoJ(_y) {
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    var zoom = voyageCamera_sidecar_1.voyageCamera.getZoom();
    var cy = _y / zoom + cam.cameraY / zoom;
    var j = Math.floor(cy / exports.spotSize);
    return j;
}
exports.convertSYtoJ = convertSYtoJ;
function convertSXtoI(_x) {
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    var zoom = voyageCamera_sidecar_1.voyageCamera.getZoom();
    var cx = _x / zoom + cam.cameraX / zoom;
    var i = Math.floor(cx / exports.spotSize);
    return i;
}
exports.convertSXtoI = convertSXtoI;
function convertIJtoXY(i, j) {
    var x = convertItoX(i);
    var y = convertJtoY(j);
    return { x: x, y: y };
}
exports.convertIJtoXY = convertIJtoXY;
function convertItoX(i) {
    var x = i * exports.spotSize + exports.spotSize / 2;
    return x;
}
exports.convertItoX = convertItoX;
function convertJtoY(j) {
    var y = j * exports.spotSize + exports.spotSize / 2;
    return y;
}
exports.convertJtoY = convertJtoY;
function addGameElevator(c) {
    var obj = get();
    assert_sidecar_1.assert.eq(c.text3, c.text3.toLowerCase(), 'elevators must be lowercase', c.text3);
    if (!obj.elevators[c.text3]) {
        obj.elevators[c.text3] = [];
    }
    obj.elevators[c.text3].push(c);
}
exports.addGameElevator = addGameElevator;
function getElevators(tag) {
    var obj = get();
    var els = obj.elevators[tag];
    assert_sidecar_1.assert.notNil(els, 'no elevator with tag', tag);
    return els;
}
exports.getElevators = getElevators;
function addGameSystem(c) {
    var obj = get();
    var key = c.text3;
    return addGameSystem2(c, key);
}
exports.addGameSystem = addGameSystem;
function addGameSystem2(c, key) {
    var data = voyageSystemsData_sidecar_1.voyageSystemsData.findBy(c.tile3.type, key);
    if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
        assert_sidecar_1.assert.eq(key, key.toLowerCase(), 'systems must be lowercase', key);
        assert_sidecar_1.assert.notEmptyString(key, 'key is empty!');
        if (data.allowMultiple) {
            var origKey = key;
            while (checkForDuplicateKey(key)) {
                key = origKey + rando_sidecar_1.rando.i(1000, 9999);
            }
            c.text3 = key;
        }
        voyageMessageSystemCreate_sidecar_1.voyageMessageSystemCreate.sendMessageAndImmediatelyExecute({
            i: c.i,
            j: c.j,
            key: key,
            systemId: get().nextSystemId++,
        });
        // assert.nil(obj.systems[key], 'duplicate system', '' + key)
        // if (obj.systems[key] != null) {
        //   console.warn('duplicate system', key, obj.systems[key])
        // }
        // voyageSystems.init(c, key)
        // obj.systems[key] = c
    }
    return data;
}
exports.addGameSystem2 = addGameSystem2;
function checkForDuplicateKey(key) {
    var obj = get();
    if (obj.systemsByKey[key] != null) {
        return true;
    }
    return false;
}
function networkAddSystem(msg) {
    var obj = get();
    var t = getSafe(msg.i, msg.j);
    assert_sidecar_1.assert.notNil(t);
    var key = msg.key;
    var id = msg.systemId;
    if (obj.systemsByKey[key] != null) {
        console.warn('duplicate system key', key, id, obj.systemsByKey[key]);
    }
    if (obj.systemsById[id] != null) {
        console.warn('duplicate system id', key, id, obj.systemsByKey[key]);
    }
    voyageSystems_sidecar_1.voyageSystems.init(t, key, id);
    obj.systemsByKey[key] = t;
    obj.systemsById[id] = t;
    obj.systems.push(t);
}
exports.networkAddSystem = networkAddSystem;
function getSystemByKey(key) {
    var obj = get();
    var sys = obj.systemsByKey[key];
    assert_sidecar_1.assert.notNil(sys, 'no system with key', key);
    return sys;
}
exports.getSystemByKey = getSystemByKey;
function getSystemByKeySafe(key) {
    var obj = get();
    var sys = obj.systemsByKey[key];
    return sys || null;
}
exports.getSystemByKeySafe = getSystemByKeySafe;
function getSystemById(id) {
    var obj = get();
    var sys = obj.systemsById[id];
    assert_sidecar_1.assert.notNil(sys, 'no system with id', id);
    return sys;
}
exports.getSystemById = getSystemById;
function getSystemByIdSafe(id) {
    var obj = get();
    var sys = obj.systemsById[id];
    return sys || null;
}
exports.getSystemByIdSafe = getSystemByIdSafe;
function getRandomFloor() {
    var tm = get();
    var width = tm.width;
    var height = tm.height;
    var options = [];
    for (var j = 0; j < height; j++) {
        for (var i = 0; i < width; i++) {
            var t = getUnsafe(i, j);
            if (t.tile2.type === voyageTileData_1.EVoyageTile.Floor) {
                options.push(t);
            }
        }
    }
    return rando_sidecar_1.rando.sample(options);
}
exports.getRandomFloor = getRandomFloor;
function getRandomFreeSystem(startsWith) {
    var tm = get();
    var width = tm.width;
    var height = tm.height;
    var options = [];
    for (var j = 0; j < height; j++) {
        for (var i = 0; i < width; i++) {
            var t = getUnsafe(i, j);
            //if (t.tile3.type === EVoyageTile.System) {
            // if (t.items.length === 0 && t.crew === null) {
            // if (t.text3) {
            //   console.log(t.text3)
            // }
            if (t.tile3.type === voyageTileData_1.EVoyageTile.System) {
                if (t.text3.startsWith(startsWith)) {
                    // console.log('found', t.text3, t.items.length, '' + t.crew)
                    if (t.items.length === 0 && t.crew.length === 0) {
                        options.push(t);
                    }
                }
            }
            // }
            //}
        }
    }
    if (options.length === 0) {
        return null;
    }
    return rando_sidecar_1.rando.sample(options);
}
exports.getRandomFreeSystem = getRandomFreeSystem;
function resetSystems() {
    var tm = get();
    var width = tm.width;
    var height = tm.height;
    tm.nextSystemId = 100;
    tm.elevators = {};
    tm.systemsByKey = {};
    tm.systemsById = {};
    tm.systems = [];
    for (var j = 0; j < height; j++) {
        for (var i = 0; i < width; i++) {
            var t = getUnsafe(i, j);
            voyageTilemapPart_sidecar_1.voyageTilemapPart.setSystemImage(t, null);
        }
    }
    // tm.breaches = []
}
exports.resetSystems = resetSystems;
